<template>
  <div class="cbl">
    <div class="cbl__header">
      <div class="cbl__header-inner">
        <div class="cbl__header-breadcrumb"><a href="/">Home</a> / {{ data.title }}</div>
        <div class="cbl__header-copy">
          <h2 class="cbl__header-title">{{ data.title }}</h2>
          <span class="cbl__header-desc">{{ data.blData.description }}</span>
        </div>
        <button @click="redirectToBody" class="cbl__filter-cta" tabindex="0">
          <svg class="cbl__filter-icon">
            <use xlink:href="#filter-icon"></use>
          </svg>
          <span>Filter</span>
        </button>
      </div>
    </div>
    <div class="cbl__body">
      <div class="cbl__item" v-for="item in data.blData.blFields" :key="item.field_title">
        <div class="cbl__item-header">
          <h5 class="cbl__item-title">{{ item.field_title }}</h5>
          <span v-if="item.field_tag" class="cbl__item-tag">{{ item.field_tag }}</span>
          <span class="cbl__item-count">{{ displayProducts(item.product_tag).length }} items</span>
        </div>
        <div class="cbl__item-desc">{{ item.field_copy }}</div>
        <div ref="productSlider" class="cbl__item-product-wrapper">
          <div :class="['cbl__item-products', { 'is--center': displayProducts(item.product_tag).length < 4 }]">
            <div v-for="product in displayProducts(item.product_tag)" :key="product.handle" class="cbl__item-product">
              <ProductCard
                type="TypeA"
                :isSecondTurn="isSecondTurn"
                :product="product"
                :callouts="data.callouts"
                :quickview="true"
                :scrollImagesTest="scrollImagesTest"
                gtmTrackId="PLP: Product Card"
                :collectionHandle="data.handle"
                :collectionTitle="data.title"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, toRefs, computed, onMounted } from 'vue';
  import ProductCard from '../../global/product-card/index.vue';
  import Swiper from 'swiper';
  import SwiperCore, { Navigation, A11y } from 'swiper/core';

  SwiperCore.use([Navigation, A11y]);

  const props = defineProps({
    data: {
      type: Object,
      required: true,
    },
  });

  const { data } = toRefs(props);
  var productSlider = ref(null);
  const scrollImagesTest = ref(null);


  onMounted(() => {
    new Swiper(productSlider.value, productCarousel.value);
    window.refreshYotpoData();
  });

  const productCarousel = computed(() => {
    return {
      slidesPerView: 1.64,
      spaceBetween: 16,
      wrapperClass: 'cbl__item-products',
      slideClass: 'cbl__item-product',
      breakpoints: {
        768: {
          slidesPerView: 2.8,
          spaceBetween: 32,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
      a11y: {
        enabled: true,
      },
    };
  });

  const isSecondTurn = computed(() => {
    const { handle } = data.value;
    return handle.toLowerCase().includes('second-turn');
  });

  const displayProducts = (productTag) => {
    const { products } = data.value;
    return products.filter((product) => product.tags.some((value) => value.toLowerCase() === productTag.toLowerCase()));
  };

  const redirectToBody = () => {
    const element = document.querySelector('#cl-body');
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition =
      window.innerWidth > 1024
        ? elementPosition + window.pageYOffset - 142
        : elementPosition + window.pageYOffset - 102;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };
</script>
